import { config, hooks, mui, React, ts, ui } from '_core';

import { DraftParams } from './types';

type FormProps = {
  params: DraftParams;
  setParams: (_p: DraftParams) => void;

  startDate?: string;
  endDate?: string;
  universeId?: number;
  frequency?: ts.enums.FREQUENCY_ENUM;
};

const Form = ({ params, setParams, startDate = null, endDate = null, universeId = null, frequency }: FormProps) => {
  const uiStyles = hooks.useUiStyles();
  const [snapshotDate, setSnapshotDate] = React.useState(params.snapshot_date || endDate);
  const [minBasketWeight, setMinBasketWeight] = React.useState(params.min_basket_weight || 0.1);
  const [maxEtfs, setMaxEtfs] = React.useState(params.max_etfs || 10);

  const [componentErrors, setComponentErrors] = React.useState([]);

  React.useEffect(() => {
    const data = {
      snapshot_date: snapshotDate,
      component_errors: componentErrors,
      min_basket_weight: minBasketWeight,
      max_etfs: maxEtfs,
    };

    setParams({ ...params, ...data });
  }, [snapshotDate, componentErrors, minBasketWeight, maxEtfs]);

  return (
    <mui.core.Box sx={uiStyles.widgetEditMode}>
      <ui.SmartDateSelector
        label="Snapshot Date"
        value={snapshotDate}
        setValue={(date) => setSnapshotDate(date)}
        minDate={startDate || config.features.start_date}
        maxDate={endDate || config.features.end_date}
        universeId={universeId}
        frequency={frequency}
        setExternalError={(e) => setComponentErrors(e ? [e] : [])}
      />
      <mui.core.Box mt={4}>
        <ui.NumericField
          textFieldProps={{
            label: 'Minimum Weight in Basket Names',
            variant: 'outlined',
            size: 'small',
            fullWidth: true,
          }}
          suffix={'%'}
          dividerOption={ts.enums.NUMBER_FORMATTERS_ENUM.HUNDRED}
          value={minBasketWeight}
          setValue={setMinBasketWeight}
        />
      </mui.core.Box>
      <mui.core.Box mt={4}>
        <ui.NumericField
          textFieldProps={{
            label: 'Max ETFs',
            variant: 'outlined',
            size: 'small',
            fullWidth: true,
          }}
          onlyInteger
          onlyPositive
          value={maxEtfs}
          setValue={setMaxEtfs}
        />
      </mui.core.Box>
    </mui.core.Box>
  );
};

export default Form;
